import actionTypes from "../actionTypes"

const updateCountries = countries => {
  return {
    type: actionTypes.SET_COUNTRIES,
    payload: countries,
  }
}

const updatePlans = plans => {
  return {
    type: actionTypes.SET_PLANS,
    payload: plans,
  }
}

export default {
  updateCountries,
  updatePlans
}